export default __webpack_public_path__ + "static/media/virti-dark.5b69fb8a.svg";